export function groupBy(array, prop) {
  return array.reduce((groups, item) => {
    const key = item[prop];
    const items = groups[key] || [];

    return {
      ...groups,
      [key]: items.concat(item)
    };
  }, {});
}

export function findMatch(array, word) {
  return array.filter(a => a.indexOf(word) > 0)[0];
}

export function compact(array) {
  return array.filter(x => x);
}

export function remove(array, key) {
  const newArr = array.slice(0);
  const index = newArr.indexOf(key);
  newArr.splice(index, 1);

  return newArr;
}

export function removeItems(arr, ...keys) {
  let newArr = arr.slice(0);
  keys.forEach(k => {
    newArr = remove(newArr, k);
  });

  return newArr;
}



// WEBPACK FOOTER //
// ./app/lib/arrays.js